import { WhiteCard } from 'components/styles_components/card';
import {
  CardOptionHintTypography,
  CardOptionTypography,
  CardTitleTypography,
} from 'components/styles_components/typography';
import { Box, Grid, Table, TableBody } from 'components/ui';
import { FormattedMessage } from 'react-intl';

import ComplianceStats from 'components/compliance_stats/container';
import ShowItemTableRow from 'components/item/show_item_table_row';
import DeleteButton from 'components/place/button/delete';
import EditButton from 'components/place/button/edit';
import PlaceMap from 'components/place/map';
import Place from 'utils/place';

const ShowItem = ({ place, space, refetch }) => {
  return (
    <Grid container spacing={2}>
      <Grid item size={{ xs: 12 }}>
        <WhiteCard
          className={Place(place).htmlClass}
          style={{ height: '100%', margin: 0, boxSizing: 'border-box', width: '100%' }}>
          <CardTitleTypography variant="h5">{place.name}</CardTitleTypography>
          <ComplianceStats
            complianceRatio={place.complianceRatio}
            overdueInspectionsTotal={place.overdueInspectionsTotal}
            incomingInspectionsTotal={place.incomingInspectionsTotal}
            pendingInspectionsTotal={place.pendingInspectionsTotal}
          />
          <Grid container spacing={2} sx={{ mb: 2, mt: 2 }}>
            <Grid item size={{ xs: 12 }}>
              <CardOptionTypography>
                <FormattedMessage id="place.address.data" />
              </CardOptionTypography>
              <Table>
                <TableBody>
                  <ShowItemTableRow label={<FormattedMessage id="place.street" />}>
                    {place.street}
                  </ShowItemTableRow>
                  <ShowItemTableRow label={<FormattedMessage id="place.zip_code" />}>
                    {place.zipCode}
                  </ShowItemTableRow>
                  <ShowItemTableRow label={<FormattedMessage id="place.city" />}>
                    {place.city}
                  </ShowItemTableRow>
                </TableBody>
              </Table>
            </Grid>
            <PlaceMap place={place} />
            <Grid item size={{ xs: 12 }}>
              <CardOptionTypography>
                <FormattedMessage id="place.contact.data" />
              </CardOptionTypography>
              <Table>
                <TableBody>
                  <ShowItemTableRow label={<FormattedMessage id="place.contact.person" />}>
                    {place.contactPerson}
                  </ShowItemTableRow>
                  <ShowItemTableRow label={<FormattedMessage id="place.contact.phone" />}>
                    {place.phone}
                  </ShowItemTableRow>
                  <ShowItemTableRow label={<FormattedMessage id="place.contact.email" />}>
                    {place.email}
                  </ShowItemTableRow>
                </TableBody>
              </Table>
            </Grid>
            {place.notes && (
              <Grid item size={{ xs: 12 }}>
                <CardOptionTypography>
                  <FormattedMessage id="place.notes" />
                </CardOptionTypography>
                <CardOptionHintTypography sx={{ m: 1 }}>{place.notes}</CardOptionHintTypography>
              </Grid>
            )}
          </Grid>
          {space.adminRole && (
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <DeleteButton place={place} space={space} />
              <EditButton place={place} space={space} refetch={refetch} />
            </Box>
          )}
        </WhiteCard>
      </Grid>
    </Grid>
  );
};

export default ShowItem;
